@if (pendingChanges() > 0) {
  <div
    class="ft-alert-section ft-slide-down"
    ft-pending-changes
  >
    <div class="ft-alert is-actionable">
      <div class="ft-alert-content">
        <h3 class="ft-heading" [innerHTML]="'flipto.components.common.pendingChanges.ConfirmYourChanges' | translate"></h3>
        <p [innerHTML]="'flipto.components.common.pendingChanges.ChangesPending' | translate: { total: pendingChanges() }"></p>
        <div class="ft-alert-actions">
          <!-- [innerHTML], not {{ }}: the compat parser $sanitize-escapes translations
               (& -> &amp;) and v1's translate directive rendered them via element.html(). -->
          <a
            class="ft-btn ft-btn-plus-1 ft-btn-default alert-confirm save"
            [class.disabled]="inactive()"
            (click)="onSave()"
            [innerHTML]="'flipto.components.common.pendingChanges.SaveAndPublish' | translate"
          ></a>
          <a class="ft-btn ft-btn-plus-1 ft-btn-text alert-cancel cancel" (click)="onCancel()">{{ 'flipto.components.common.pendingChanges.CancelAll' | translate }}</a>
        </div>
      </div>
    </div>
  </div>
}
